import { EXPORT_JOBS_PAGE } from "routes/route.constant";
import ExportJobs from "./ExportJobs";

const route = {
  path: EXPORT_JOBS_PAGE,
  element: ExportJobs,
};

export default route;
